import classnames from 'classnames';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import ClassificationResultsFilter from '~/components/classification_results_filter';
import PermissionChecker from '~/components/permission_checker';
import Permissions from '~/settings/permissions';
import { useComparisonGrid } from '../providers/comparison_grid';
const ClauseTitleColumn = () => {
    const { anchorDoc, comparatorDocs, tagsColumnNames, categories, descriptors, selectedCategories, setSelectedCategories, selectedDescriptors, setSelectedDescriptors, selectedRowIndex, setSelectedRowIndex, areDiffsVisible, setAreDiffsVisible, areCommentsVisible, setAreCommentsVisible, } = useComparisonGrid();
    const getNumCommentsInRow = (clauseName) => {
        return [anchorDoc, ...comparatorDocs].reduce((acc, doc) => {
            var _a;
            const foundClauses = (_a = doc.classificationMap) === null || _a === void 0 ? void 0 : _a.get(clauseName);
            let commentCount = 0;
            foundClauses === null || foundClauses === void 0 ? void 0 : foundClauses.forEach(foundClause => {
                var _a;
                const seenClassifications = new Set();
                for (const classification of foundClause.classifications) {
                    if (!seenClassifications.has(classification.name)) {
                        commentCount += classification.comments ? (_a = classification.comments) === null || _a === void 0 ? void 0 : _a.length : 0;
                        seenClassifications.add(classification.name);
                    }
                }
            });
            if (commentCount > 0) {
                acc.docNames.set(doc.fileName, {
                    name: doc.fileName,
                    count: commentCount,
                });
            }
            acc.count = acc.count ? acc.count + commentCount : commentCount;
            return acc;
        }, { count: 0, docNames: new Map() });
    };
    let startingIndex = 0;
    return (React.createElement("div", { className: 'anchor-titles' },
        React.createElement("div", { className: 'header cell', id: '0-0', "data-testid": 'cell-0-0' },
            React.createElement("div", { className: 'category-title', "data-testid": 'grid-view-category-select-trigger' },
                React.createElement("h5", null, "Classifications"),
                React.createElement(ClassificationResultsFilter, { categories: categories, selectedCategories: selectedCategories, setSelectedCategories: setSelectedCategories, descriptors: descriptors, selectedDescriptors: selectedDescriptors, setSelectedDescriptors: setSelectedDescriptors }))),
        React.createElement("div", { className: 'scroll-space anchor' }),
        tagsColumnNames.map(clauseName => {
            const rowIndex = startingIndex + 1;
            const columnId = 0;
            const cellId = `${columnId}-${rowIndex}`;
            const activeRow = selectedRowIndex === rowIndex;
            startingIndex++;
            const category = clauseName.split(':')[0];
            const descriptor = clauseName.split(':')[1].trim();
            const { count: numCommentsInRow, docNames } = getNumCommentsInRow(clauseName);
            const cellClassName = classnames('title cell', { active: activeRow, 'comments-visible': areCommentsVisible });
            const diffIconClass = classnames('click-icon', { active: areDiffsVisible });
            const commentIconClass = classnames('click-icon', { active: areCommentsVisible });
            const titleCategoryClass = classnames('title-category', { active: activeRow });
            return (React.createElement("div", { key: cellId, "data-testid": `cell-${cellId}`, className: cellClassName, onClick: () => setSelectedRowIndex(rowIndex) },
                React.createElement("div", { className: titleCategoryClass }, category.toUpperCase()),
                descriptor,
                activeRow && (React.createElement("div", { className: 'icons' },
                    React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.VIEW_CLAUSE_DIFFS] },
                        React.createElement("span", { className: diffIconClass, title: 'Show Clause Diffs', onClick: () => setAreDiffsVisible(!areDiffsVisible) },
                            React.createElement("i", { className: 'fa-align-justify fad fa-fw' }))),
                    React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.VIEW_CLAUSE_COMMENTS] },
                        React.createElement("span", { className: commentIconClass, title: 'Show Comments', onClick: () => setAreCommentsVisible(!areCommentsVisible) },
                            React.createElement("i", { className: 'fa-comments fas fa-fw' }))))),
                numCommentsInRow > 0 &&
                    React.createElement(OverlayTrigger, { placement: 'bottom', overlay: React.createElement(Popover, { id: 'grid-comment-popover', className: 'grid-comment-popover' },
                            React.createElement(Popover.Title, null, "Comments In Documents"),
                            React.createElement(Popover.Content, null,
                                React.createElement("ul", null, Array.from(docNames.values()).map((dn, index) => React.createElement("li", { key: `docname-${index}-${dn.name}` },
                                    dn.name,
                                    " (",
                                    dn.count,
                                    ")"))))) },
                        React.createElement("div", { className: 'num-comments' },
                            React.createElement("span", null,
                                React.createElement("i", { className: 'fad fa-comments' })),
                            `(${numCommentsInRow}) comments`))));
        })));
};
export default ClauseTitleColumn;
